import React from 'react'
import styled from 'styled-components'

import { Box } from '../Box'

const Root = styled(Box)`
  border: 1px solid ${({ theme }) => theme.colors.border};
  padding: 1rem;
`

const EventCTA = () => {
  return <Root></Root>
}

export default EventCTA
